<template>
  <div class="container-fluid mt-3">
    <div class="row p-3">
      <div class="col col-sm-10">
        <h3>MyProfile</h3>
      </div>

      <div class="col-md-12 mt-3">
        <div class="card">
          <div class="card-body">
            <form @submit="editUser">
              <div class="form-group row">
                <label
                  for="lastName"
                  class="col-sm-2 col-form-label font-weight-bold"
                >LastName</label>

                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    id="lastName"
                    v-model="crewProfile.last_name"
                    :readonly="!editableCrew"
                    placeholder="LastName"
                  >
                </div>
              </div>

              <div class="form-group row">
                <label
                  for="firstName"
                  class="col-sm-2 col-form-label font-weight-bold"
                >FirstName</label>

                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    id="firstName"
                    v-model="crewProfile.first_name"
                    :readonly="!editableCrew"
                    placeholder="FirstName"
                  >
                </div>
              </div>

              <div class="form-group row">
                <label
                  for="middleName"
                  class="col-sm-2 col-form-label font-weight-bold"
                >MiddleName</label>

                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    id="middleName"
                    v-model="crewProfile.middle_name"
                    :readonly="!editableCrew"
                    placeholder="MiddleName"
                  >
                </div>
              </div>



              <!--<div class="form-group row">
                                <label for="address" class="col-sm-2 col-form-label font-weight-bold">Address</label>

                                <div class="col-sm-10">
                                    <input type="text"
                                           class="form-control"
                                           id="address"
                                           placeholder="Address">
                                </div>
                            </div>-->

              <div class="form-group row">
                <label
                  for="email"
                  class="col-sm-2 col-form-label font-weight-bold"
                >Email</label>

                <div class="col-sm-10">
                  <input
                    type="email"
                    class="form-control"
                    id="email"
                    v-model="crewProfile.email"
                    :readonly="!editableCrew"
                    placeholder="Email"
                  >
                </div>
              </div>

              <div class="text-right">
                <!--                                <button id="submitBtn" type="submit" class="btn btn-primary btn-sm">-->
                <!--                                    <i class="fa fa-save"></i>-->
                <!--                                    {{editableCrew ? 'SAVE':'UPDATE'}}-->
                <!--                                </button>-->
                <!--                                &nbsp;&nbsp;-->
                <button
                  class="btn btn-sm btn-outline-secondary font-weight-bolder"
                  @click="goBack"
                >
                  <span><i class="fas fa-backward" /></span>
                  GO BACK
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {formMixins} from "../../../mixins/formMixins";
    import {mapActions,mapGetters} from 'vuex';
    export default {
        mixins: [formMixins],
        name: "CrewProfile",
        methods:{
            ...mapActions(['viewCrew','setEditableCrew','updateCrew']),

            async editUser(e){
                e.preventDefault();
                if(this.editableCrew){
                    if(await this.confirmUpdateAlert('Are you sure you want to update your record?')){
                        this.updateCrew(this.crew);
                    }
                }
                this.setEditableCrew();
            }
        },

        computed:{
            ...mapGetters(['userLogin','crewProfile','editableCrew']),
        },

        created() {
            this.viewCrew(this.userLogin.id);
        }
    }
</script>

<style scoped>

</style>